<template>
  <!-- 成员样本动态 -->
  <div class="sampleDynamics">
    <el-table class="mg-t-20" :data="tableData.data" border style="width: 100%">
      <el-table-column prop="name" label="成员" align="center">
      </el-table-column>
      <el-table-column prop="desc" label="合同编号" align="center">
      </el-table-column>
      <el-table-column prop="update_time" label="样本名称" align="center">
      </el-table-column>
      <el-table-column prop="user_number" label="当前进度" align="center">
      </el-table-column>
      <el-table-column prop="update_time" label="最近更新时间" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <el-button
            @click="checkDetails(scope.row.uuid)"
            type="text"
            size="small"
            >查看详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :total="tableData.total"
      :per_page="tableData.per_page"
      :current_page="tableData.current_page"
      @handleCurrentChange="handleCurrentChange"
      @handleSizeChange="handleSizeChange"
    />

    <el-dialog
      title="样本动态"
      :visible.sync="dynamicDialog"
      width="50%"
      :close-on-click-modal="false"
    >
      <DynamicTime :uuid="dynamicUuid" />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dynamicDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import DynamicTime from "./dynamicTime.vue";
import pagination from "../../../components/pagination.vue";

export default {
  name: "sampleDynamics",
  data() {
    return {
      customerGroupForm: {
        search_keyword: "",
        search_start_time: "",
        search_end_time: "",
      },
      tableData: {
        data: [],
        per_page: 10,
        current_page: 1,
        total: 0,
      },
      dynamicDialog: false,
      dynamicUuid: "",
    };
  },
  components: {
    pagination,
    DynamicTime,
  },
  props: ["uuid"],
  created() {
    this.getList();
  },
  methods: {
    checkDetails(uuid) {
      this.dynamicUuid = uuid;
      this.dynamicDialog = true;
    },
    //获取数据
    getList() {
      this.axios({
        method: "get", //请求方法
        headers: {
          "Content-Type": "text/html;charset=UTF-8",
          "X-Access-Token": this.storage.get("__token"),
          Authorization: `Bearer ${this.storage.get("__token")}`,
        },
        url: ` https://time.api.boyalife.cn/v1/cms/UserGroup?page_size=${this.tableData.per_page}&page_index=${this.tableData.current_page}&search_keyword=${this.customerGroupForm.search_keyword}&search_start_time=${this.customerGroupForm.search_start_time}&search_end_time=${this.customerGroupForm.search_end_time}`,
      })
        .then((res) => {
          this.tableData = res.data.result;
        })
        .catch((err) => {
          this.$message.error(err.response.data.error.message);
        });
    },
    handleSizeChange(v) {
      this.tableData.per_page = v;
      this.getList();
    },
    handleCurrentChange(v) {
      this.tableData.current_page = v;
      this.getList();
    },
  },
};
</script>
<style scoped></style>
